import React from "react";
import { Container, Row, Col, Form, Button, ProgressBar } from "react-bootstrap";
import { useLocalStorage } from "../../useLocalStorage";
import config from "./config.json";

const Step5 = ({ prevStep, nextStep }) => {
  const currentStep = 5;

  const [dataLocal, setDataLocal] = useLocalStorage("audit_energetique_step5", {
    start_work: "",
  });

  const handleChangeStart = (e) => {
    setDataLocal({ ...dataLocal, start_work: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!dataLocal.start_work) return;
    nextStep();
  };

  return (
    <Container>
      <ProgressBar now={(currentStep / config.totalSteps) * 100} />

      <Form onSubmit={handleSubmit}>
        {/* Titre */}
        <Row>
          <Col>
            <h2>{config.step5.step}</h2>
            <h3>{config.step5.title}</h3>
          </Col>
        </Row>

        {/* Options de démarrage des travaux */}
        <Row className="mb-3">
          <Col>
            <p>{config.step5.label}</p>
          </Col>
        </Row>

        <Row className="mb-3 container-bloc">
          <Col
            className={`m-2 icon-container ${
              dataLocal.start_work === "le_plus_tot_possible" ? "selected" : ""
            }`}
          >
            <Form.Check
              type="radio"
              label="Le plus tôt possible"
              value="le_plus_tot_possible"
              checked={dataLocal.start_work === "le_plus_tot_possible"}
              onChange={handleChangeStart}
              name="start_work"
            />
          </Col>

          <Col
            className={`m-2 icon-container ${
              dataLocal.start_work === "dans_les_6_prochains_mois" ? "selected" : ""
            }`}
          >
            <Form.Check
              type="radio"
              label="Dans les 6 prochains mois"
              value="dans_les_6_prochains_mois"
              checked={dataLocal.start_work === "dans_les_6_prochains_mois"}
              onChange={handleChangeStart}
              name="start_work"
            />
          </Col>

          <Col
            className={`m-2 icon-container ${
              dataLocal.start_work === "plus_tard_je_ne_sais_pas" ? "selected" : ""
            }`}
          >
            <Form.Check
              type="radio"
              label="Plus tard / Je ne sais pas"
              value="plus_tard_je_ne_sais_pas"
              checked={dataLocal.start_work === "plus_tard_je_ne_sais_pas"}
              onChange={handleChangeStart}
              name="start_work"
            />
          </Col>
        </Row>

        {/* Boutons */}
        <Row className="mt-3">
          <Col className="d-flex justify-content-between">
            <Button variant="secondary" onClick={prevStep}>
              Précédent
            </Button>
            <Button type="submit" variant="primary">
              Suivant
            </Button>
          </Col>
        </Row>
      </Form>
    </Container>
  );
};

export default Step5;
